import { Check, ChevronDown, ChevronUp } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/shared/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from '@/shared/components/ui/dropdown-menu'

const OPTIONS = [
  {
    value: 'all',
    label: 'All Sources',
  },
  {
    value: 'linkedin',
    label: 'LinkedIn',
  },
  {
    value: 'facebook',
    label: 'Facebook',
  },
  {
    value: 'offline',
    label: 'Offline',
  },
]

export default function SourceFilter({ value, onChange }) {
  const [open, setOpen] = useState(false)
  const selected = OPTIONS.find((item) => item.value === value) || OPTIONS[0]

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          className="h-11 w-full justify-between rounded-full border bg-white px-4 text-sm font-medium shadow-sm sm:w-40"
        >
          {selected.label}

          {open ? (
            <ChevronUp className="ml-4 size-4 shrink-0" />
          ) : (
            <ChevronDown className="ml-4 size-4 shrink-0" />
          )}
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        align="end"
        className="w-[calc(100vw-48px)] max-w-56 rounded-3xl p-2 sm:w-56"
      >
        <DropdownMenuLabel className="text-base">
          Filter by source
        </DropdownMenuLabel>

        {OPTIONS.map((option) => (
          <DropdownMenuItem
            key={option.value}
            onSelect={() => onChange(option.value)}
            className="flex items-center justify-between rounded-xl"
          >
            {option.label}

            {value === option.value && (
              <Check className="size-4 text-indigo-600" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
